import React from "react"

const EmptyBlock = props => {
  return <div className={props.className + " bg-white w-100"}></div>
}

export default EmptyBlock
